import application from 'application/application';

application

	.directive('ngLink', ['$state', $state => ({
		restrict: 'A',
		scope: {
			ngLinkParams: '='
		},
		link(scope, element, attrs) {

			$(element).on('click', event => {

				if (event.ctrlKey || event.metaKey)

					window.open($state.href(attrs.ngLink, scope.ngLinkParams, { inherit: false }), '_blank');

				else

					$state.go(attrs.ngLink, scope.ngLinkParams, { inherit: false });


			});

		}
	})]);
